



































































import { ServiceInstance } from '@/data/models/serviceinstance.model';
import { CrudService } from '@/data/services/crud.service';
import { Component, Inject, Ref, Vue, Watch } from 'vue-property-decorator';
import CalendarioServiziFilter from './CalendarioServiziFilter.vue';
import CalendarioServiziList from './CalendarioServiziList.vue';
import store, { State } from '@/store';
import { Search } from '@/data/models/search.model';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';

@Component({
	components: {
		CalendarioServiziList,
		CalendarioServiziFilter
	}
})
export default class CalendarioServizi extends Vue {

	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;
	@Inject('ServiceInstanceService') serviceInstanceService!: ServiceInstanceService;
	
	@Ref('list') list!: CalendarioServiziList;
	@Ref('filter') filter!: CalendarioServiziFilter;

	state!: State;
	rangetitle: string = '';
	singleday: boolean = false;

	selected: ServiceInstance[] = [];
	
	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.rangetitle = this.buildRangeTitle(event.rangeTmp['startdate']);
		this.list.loadServices();
	}

	dayNext() {
		this.filter.dayNext();
	}

	dayBefore() {
		this.filter.dayBefore();
	}

	applyAction(action: string) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-serviceistance-' + action) as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const ids = this.selected.map(s => s.id);
				this.serviceInstanceService.action(ids, action).then(() => {
					this.filter.search();
					this.selected = [];
					this.$buefy.notification.open({
						message: this.$t('serviceistance-' + action + '-success').toString(),
						type: 'is-success',
					});
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				});
			}
		});
	}

	private buildRangeTitle(rangeFilter?: any) {
		if (!rangeFilter) return '';
		const start = new Date(parseInt(rangeFilter.start, 10) * 1000);
		const stop = new Date(parseInt(rangeFilter.stop, 10) * 1000);
		if (stop.getTime() - start.getTime() <= 1000 * 60 * 60 * 24) {
			this.singleday = true;
			return start.toLocaleDateString();
		} else {
			this.singleday = false;
			return start.toLocaleDateString() + ' - ' + stop.toLocaleDateString();
		}
	}

	deleteAll() {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-servizi-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const rows = this.list.rows;
				const ids = rows.map(r => r.id);
				this.serviceInstanceService.deleteAll(ids).then(() => {
					this.list.loadServices();
				});
			},
		});
	}

}

